import { Outlet } from 'react-router-dom';

export function CreatorHubPage() {
  return <Outlet />;
}
